module.exports = __webpack_public_path__ + "static/media/landing@1x.93ffaa2a.webm";